(() => {
  const sections = document.querySelectorAll('.mt-training-modes-grid-x4[data-section-id]');

  if (!sections.length) return;

  const playVideo = (video) => {
    video.muted = true;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  };

  const pauseVideo = (video) => {
    video.pause();
    video.currentTime = 0;
  };

  sections.forEach((section) => {
    const cards = Array.from(section.querySelectorAll('.mt-training-modes-grid-x4__card'));
    const enableHover = window.matchMedia('(hover: hover)').matches;

    const pauseOtherVideos = (currentVideo) => {
      cards.forEach((card) => {
        const video = card.querySelector('video');
        if (video && video !== currentVideo) {
          pauseVideo(video);
        }
      });
    };

    cards.forEach((card) => {
      const media = card.querySelector('.mt-training-modes-grid-x4__card-media');
      const video = card.querySelector('video');

      if (!media || !video) return;

      if (enableHover) {
        card.addEventListener('mouseenter', () => {
          pauseOtherVideos(video);
          playVideo(video);
        });

        card.addEventListener('mouseleave', () => {
          pauseVideo(video);
        });
      } else {
        media.addEventListener('click', () => {
          if (!video.paused) {
            pauseVideo(video);
            return;
          }

          pauseOtherVideos(video);
          playVideo(video);
        });
      }
    });
  });
})();
